<template>
    <div class="djzx">
        <!-- 头部 -->
        <navbar-header></navbar-header>
        <!-- 背景 -->
        <!-- 背景层 -->
        <div class="bg_box"></div>

        <!-- 新闻和日历 -->
        <ri-li></ri-li>

        <!-- 会议列表 -->
        <meeting-list name="三会一课" :id="1" :index="0"></meeting-list>

        <meeting-list name="党群活动" :id="2" :index="1"></meeting-list>

        <xian-feng-zhan name="组织先锋展" :id="10"></xian-feng-zhan>

        <!-- 底部 -->
        <nav-footer></nav-footer>
    </div>
</template>

<script>
import NavbarHeader from '@/components/index/NavbarHeader'
import NavFooter from '@/components/common/NavFooter'
import RiLi from "@/components/zzsh/RiLi"
import MeetingList from "@/components/zzsh/MeetingList"
import XianFengZhan from "@/components/zzsh/XianFengZhan"
    export default {
        components: {
            NavbarHeader,
            NavFooter,
            RiLi,
            MeetingList,
            XianFengZhan,
        },
        data() {
            return {
                id: 1,
            }
        },
    }
</script>

<style lang="scss" scoped>
.djzx {
    position: relative;
    left: 0;
    top: 0;
    .bg_box {
        width: 100%;
        height: 746px;
        margin: 0 auto;
        background: url("../assets/static/index/btm_bg.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 300px;
        z-index: -1;
    }
}
.img_box {
    width: 1200px;
    margin: 30px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .img_item {
        width: 371px;
        height: 94px;
        background-color: #fff;
    }
}
</style>